import React, { useEffect, useState } from "react";
import { fetchEvaluation } from "../../api/Evaluation";
import EditorRenderer from "../EditorRenderer";

const TeacherTraning = () => {
  const [evaluation, setEvaluation] = useState([]);
  const [parsedBlocks, setParsedBlocks] = useState([]);

  useEffect(() => {
    const getEvaluation = async () => {
      const data = await fetchEvaluation();
      setEvaluation(data);
    };
    getEvaluation();
  }, []);

  const evaluationFilter = evaluation.filter(
    (item) => item.category?.name.toLowerCase() === "teachertraning"
  );

  useEffect(() => {
    if (!parsedBlocks.length && evaluationFilter.length) {
      let blocksArray = [];
      try {
        const raw = evaluationFilter[0]?.description;
        if (raw) {
          const outer = JSON.parse(raw);
          const inner = outer[0];
          if (inner?.blocks && Array.isArray(inner.blocks)) {
            blocksArray = inner.blocks;
          }
        }
      } catch (err) {
        console.error("Parsing error:", err);
      }

      setParsedBlocks(blocksArray);
    }
  }, [evaluationFilter, parsedBlocks.length]);

  return (
    <div className="flex flex-col gap-4 mb-[4rem]">
      {parsedBlocks.length > 0 && <EditorRenderer blocks={parsedBlocks} />}
   

      <div className="flex flex-col gap-4">
        <p className="text-gray-400 text-xl font-bold">
          ক্লাস : রেকর্ডেড ও Zoom{" "}
        </p>

        <div className="flex gap-4 items-center mb-[4rem] mt-[1rem]">
          <p className="text-gray-300  text-xl">
            অথবা WhatsApp করুন-{" "}
            <strong className="text-[#22BEFF]">01711055752</strong>
          </p>
          <button
            className="px-[1.25rem] py-[0.5rem] text-base border border-[#22beff]  text-[#22beff] hover:text-[#081a28] hover:bg-[#22beff]  rounded-md font-bold cursor-pointer"
            onClick={() =>
              window.open("https://forms.gle/MWgJ4zyJh3nDr6YdA", "_blank")
            }
          >
            ট্রেনিং কোর্সটি কিনুন
          </button>
        </div>
      </div>
    </div>
  );
};

export default TeacherTraning;
